import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withDetailedIcon } from '../DetailedIcon';
var innerSvg = '<path class="DetailedIcon__secondary-color-fill" d="M39.25,39.125A2.759,2.759,0,0,0,42,36.375V15.75A2.758,2.758,0,0,0,39.25,13H9.75A2.758,2.758,0,0,0,7,15.75V36.375a2.759,2.759,0,0,0,2.75,2.75Zm0-11.629v8.879H12l11.405-11.4a1.48,1.48,0,0,1,2.093,0l3.393,3.393,4.873-4.873a1.48,1.48,0,0,1,2.093,0l3.393,3.393Z"/><path class="DetailedIcon__foreground-color-fill" d="M24.973,6.571h0L26.538,9.18l.749,1.249h8.142V29.714H4.571V10.429h8.141l.749-1.249,1.565-2.609h9.946m0-2.571H15.027a2.573,2.573,0,0,0-2.2,1.248L11.257,7.857H8.429a1.286,1.286,0,0,0-2.572,0H4.571A2.579,2.579,0,0,0,2,10.429V29.714a2.579,2.579,0,0,0,2.571,2.572H35.429A2.579,2.579,0,0,0,38,29.714V10.429a2.579,2.579,0,0,0-2.571-2.572H28.743L27.178,5.248A2.573,2.573,0,0,0,24.973,4Z"/><path class="DetailedIcon__accent-color-fill" d="M32.857,11.714A1.286,1.286,0,1,0,34.143,13a1.285,1.285,0,0,0-1.286-1.286Z"/><path class="DetailedIcon__foreground-color-fill" d="M20,13a6.429,6.429,0,1,1-6.429,6.429A6.436,6.436,0,0,1,20,13m0-2.571a9,9,0,1,0,9,9,9,9,0,0,0-9-9Z"/>';
export var CameraSVG = function CameraSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CameraSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withDetailedIcon(CameraSVG);